/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hc_Domains_Answer_2Inputs */

const en_hc_domains_answer_2 = /** @type {(inputs: Hc_Domains_Answer_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creator and Sovereign plans include a free .com domain for your storefront. Go to Site Commander → Domain Mastery to claim or connect your domain.`)
};

const es_hc_domains_answer_2 = /** @type {(inputs: Hc_Domains_Answer_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los planes Creator y Sovereign incluyen un dominio .com gratuito para tu tienda. Ve a Comando del Sitio → Dominio para reclamar o conectar tu dominio.`)
};

const fr_hc_domains_answer_2 = /** @type {(inputs: Hc_Domains_Answer_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les forfaits Creator et Sovereign incluent un domaine .com gratuit pour votre vitrine. Allez dans Site Commander → Maîtrise de domaine pour le réclamer ou le connecter.`)
};

const de_hc_domains_answer_2 = /** @type {(inputs: Hc_Domains_Answer_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creator- und Sovereign-Pläne enthalten eine kostenlose .com-Domain für deine Storefront. Gehe zu Site Commander → Domain-Meisterschaft, um deine Domain zu beanspruchen oder zu verbinden.`)
};

/** @type {(inputs: Hc_Domains_Answer_2Inputs) => LocalizedString} */
const ja_hc_domains_answer_2 = en_hc_domains_answer_2;

/** @type {(inputs: Hc_Domains_Answer_2Inputs) => LocalizedString} */
const zh_hc_domains_answer_2 = en_hc_domains_answer_2;

/** @type {(inputs: Hc_Domains_Answer_2Inputs) => LocalizedString} */
const ar_hc_domains_answer_2 = en_hc_domains_answer_2;

/** @type {(inputs: Hc_Domains_Answer_2Inputs) => LocalizedString} */
const id_hc_domains_answer_2 = en_hc_domains_answer_2;

/** @type {(inputs: Hc_Domains_Answer_2Inputs) => LocalizedString} */
const it_hc_domains_answer_2 = en_hc_domains_answer_2;

/** @type {(inputs: Hc_Domains_Answer_2Inputs) => LocalizedString} */
const ru_hc_domains_answer_2 = en_hc_domains_answer_2;

/** @type {(inputs: Hc_Domains_Answer_2Inputs) => LocalizedString} */
const pt_hc_domains_answer_2 = en_hc_domains_answer_2;

/** @type {(inputs: Hc_Domains_Answer_2Inputs) => LocalizedString} */
const ko_hc_domains_answer_2 = en_hc_domains_answer_2;

/**
* | output |
* | --- |
* | "Creator and Sovereign plans include a free .com domain for your storefront. Go to Site Commander → Domain Mastery to claim or connect your domain." |
*
* @param {Hc_Domains_Answer_2Inputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const hc_domains_answer_2 = /** @type {((inputs?: Hc_Domains_Answer_2Inputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hc_Domains_Answer_2Inputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_hc_domains_answer_2(inputs)
	if (locale === "es") return es_hc_domains_answer_2(inputs)
	if (locale === "fr") return fr_hc_domains_answer_2(inputs)
	if (locale === "de") return de_hc_domains_answer_2(inputs)
	if (locale === "ja") return ja_hc_domains_answer_2(inputs)
	if (locale === "zh") return zh_hc_domains_answer_2(inputs)
	if (locale === "ar") return ar_hc_domains_answer_2(inputs)
	if (locale === "id") return id_hc_domains_answer_2(inputs)
	if (locale === "it") return it_hc_domains_answer_2(inputs)
	if (locale === "ru") return ru_hc_domains_answer_2(inputs)
	if (locale === "pt") return pt_hc_domains_answer_2(inputs)
	return ko_hc_domains_answer_2(inputs)
});